import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs';
import {CartStore} from '../stores/cart.store';
import {RestaurantStore} from '../stores/restaurant.store';

@Injectable({
  providedIn: 'root'
})
export class CloseTabGuard implements CanActivate {
  constructor(private cartStore: CartStore,
              private restaurantStore: RestaurantStore,) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!!this.cartStore.tab || !!this.cartStore.groupTab) {
      return true;
    }
    this.restaurantStore.backToStorePage(false, state.url);
  }
}
